'use client';

import {FC} from 'react';
import {useHubspotForm} from '@aaronhayes/react-use-hubspot-form';

import {renderUtils} from '@zoefin/design-system';

import formStyles from './formStyles';

import styles from './styles.module.scss';

const FORM_CONTAINER_ID = 'footerHSForm';

const Newsletter: FC = () => {
  useHubspotForm({
    portalId: '2939574',
    formId: 'a49a0949-f764-49b2-9878-cfa444be4c7d',
    target: `#${FORM_CONTAINER_ID}`,
    onFormReady: () => {
      // Inject custom styles into the iFrame
      const iFrame = document.getElementById(
        'hs-form-iframe-0',
      ) as HTMLIFrameElement;

      const style = document.createElement('style');

      style.textContent = formStyles;

      iFrame?.contentDocument?.head.appendChild(style);
    },
  });

  renderUtils.useMount(() => {
    /**
     * Fix for the Hubspot forms error -> `The onFormReady function in hbspt.forms.create requires jQuery`
     * Source : https://community.hubspot.com/t5/APIs-Integrations/Form-callback-throws-unrelated-jquery-error/m-p/232127/highlight/true#M11023
     */
    window.jQuery =
      window.jQuery ||
      (() => ({
        // these are all methods required by HubSpot
        change: () => {
          // Do nothing
        },
        trigger: () => {
          // Do nothing
        },
      }));
  });

  return (
    <section className={styles['section-newsletter']}>
      <div className="default-container">
        <div className={styles['newsletter']}>
          <div className={styles['newsletter__text']}>
            <p>Join our newsletter</p>
            <h3>
              Relevant and curated wealth stories, resources, & recommendations.
              delivered to your inbox weekly.
            </h3>
          </div>
          <div id={FORM_CONTAINER_ID} className={styles['newsletter__form']} />
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
